import { requst } from './config'

/* 登录环境 */
export const getSystemInfo = () => requst.get('/systemInfo')

/* 用户相关信息，项目 ID 等等 */
export const getUserInfoApi = () => requst.get('/getInfo')

/* 用户权限信息 */
export const getAuthInfoApi = () => requst.get('/getAuth')

/* 获取 ProjectBase 数据 */
export const getProjectBaseDataApi = projectId => {
    const url = `/setting/project/${projectId}`
    return requst.get(url)
}

// 获取单项目，工作日效文本
export const getFleetSummaryTextApi = (date, projectId) => {
    const url = `/fleetSummary/getInfo?produceDate=${date}&projectId=${projectId}`
    return requst.get(url)
}

// 获取有权限的 location 列表
export const getAuthLocationDataApi = () => {
    const url = `/setting/location/getEntryMenuList`
    return requst.get(url)
}

// 获取各菜单录入项大日历的 状态
export const getListCalendarStatusApi = ({ projectId, locationId, menuCode, startDay, endDay }) => {
    const url = `/monitor/dailyStatus/listCalendarStatus?projectId=${projectId}&locationId=${locationId}&menuCode=${menuCode}&startDay=${startDay}&endDay=${endDay}`
    return requst.get(url)
}

/* 项目分页列表 */
export const getProjectListApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = `/setting/project/queryListByUserId?` + result
    return requst.get(url)
}

/* 项目分页列表 */
export const changeProjectApi = projectId => {
    const url = `/setting/project/updateProjectToUser/${projectId}`
    return requst.post(url)
}

/* 录入项提交完成状态 */
export const postCompleted = params => {
    const url = `/monitor/dailyStatus`
    return requst.post(url, params)
}

/* 录入项状态回显 */
export const getCompleted = (params) => {
    const url = `/monitor/dailyStatus/getInfo`
    return requst.post(url, params)
}

/* 数据可编辑范围 */
export const pushUnlockDate = (params) => {
    const url = `/setting/project/updateUnlockDate`
    return requst.put(url, params)
}

/* HSE 导入 1.0 */
export const pushHSEImportData = (params) => {
    const url = `/monitor/hse/diary/importFlag`
    return requst.post(url, params)
}

/* HSE 导入 2.0 Flag 登录 */
export const postHSEFlagLoginData = (params) => {
    const url = `http://47.239.23.211:8080/auth/login`
    return requst.post(url, params)
}

/* HSE 导入 2.0 Flag 获取HSE card数据 */
export const postHSEFlagDataData = (params, token) => {
    const url = `http://47.239.23.211:8080/flag-business/megaShare/getLocationSopData`
    return requst.post(url, params, {
        headers: {
            Authorization: "Bearer " + token, // <-- 关键：带上token
        },
    })
}

/* HSE 导入 2.0 Flag 获取HSE event数据 */
export const postHSEFlagEventDataData = (params, token) => {
    const url = `http://47.239.23.211:8080/flag-business/megaShare/getLocationEventsData`
    return requst.post(url, params, {
        headers: {
            Authorization: "Bearer " + token, // <-- 关键：带上token
        },
    })
}

/* HSE 导入 2.0 Flag 获取HSE Exposure */
export const postHSEFlagExposureDataData = (params, token) => {
    const url = `http://47.239.23.211:8080/flag-business/megaShare/getLocationExposureHoursData`
    return requst.post(url, params, {
        headers: {
            Authorization: "Bearer " + token, // <-- 关键：带上token
        },
    })
}

/* HSE 导入 2.0 Flag 获取HSE Incidents */
export const postHSEFlagIncidentDataData = (params, token) => {
    const url = `http://47.239.23.211:8080/flag-business/megaShare/getLocationIncidentReportData`
    return requst.post(url, params, {
        headers: {
            Authorization: "Bearer " + token, // <-- 关键：带上token
        },
    })
}

// HSE 导入 2.0 Flag 获取 对应 code
export const getFlagCodeDataApi = (params, projectId) => {
    // 数组转逗号间隔字符串
    const paramStr = params.join(',')

    const url = `/system/dict/data/listByFlag?projectId=${projectId}&flagCodeList=${paramStr}`

    return requst.get(url)
}

/* MMO 导入 Flag 获取MMO card数据 */
export const postMMOFlagDataData = (params, token) => {
    const url = `http://47.239.23.211:8080/flag-business/megaShare/getLocationMmoData`
    return requst.post(url, params, {
        headers: {
            Authorization: "Bearer " + token, // <-- 关键：带上token
        },
    })
}

/* 易耗品 导入 */
export const pushConsumableImportData = (params) => {
    const url = `/monitor/consumable/importFlag`
    return requst.post(url, params)
}

/* 工作日志 海洋 导入 */
export const pushActivityDiaryImportData = ({ projectId, locationId, produceDate }) => {
    const url = `/monitor/activity/diary/autoImport?projectId=${projectId}&locationId=${locationId}&produceDate=${produceDate}`
    return requst.get(url)
}

/* 工作日志 拖缆 导入 */
export const pushActivityDiaryStreamerImportData = ({ projectId, locationId, produceDate }) => {
    const url = `/monitor/acquisition/streamer/getStreamerDetailForActivity?projectId=${projectId}&locationId=${locationId}&produceDate=${produceDate}`
    return requst.get(url)
}

/* 获取分公司列表 */
export const getBranchCompanyList = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params ?? {})
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = `/system/dept/branchCompanyList?` + result
    return requst.get(url)
}

/* 获取施工队伍列表 */
export const getCrewList = deptCode => {
    const url = `/system/dept/seismicTeamList?deptCode=${deptCode}`
    return requst.get(url)
}

/* 子系统后端票据登录接口 */
export const getLoginByTicketApi = (ticket) => {
    const url = `/loginByTicket?ticket=${ticket}`
    return requst.get(url)
}

// 子系统登出接口
export const getAuthLogoutApi = ticket => {
    const url = `http://8.222.251.40:8000/auth/logoutByTicket?ticket=${ticket}`
    return requst.get(url)
}

// 知识库登录接口
export const postLoginMaster = (params) => {
    const url = `http://8.222.251.40:8000/auth/login`
    return requst.post(url, params)
}